import { patch } from "../../../utils/axios-config";
import { DISABLE_ACADEMICYEAR } from "../../../utils/constants";

export const disableAcademicYear = async (id: string) => await patch<any, any>(`${DISABLE_ACADEMICYEAR}${id}`, {});